import { render, staticRenderFns } from "./GenericTHGCO2EquivalentTable.vue?vue&type=template&id=dd4f322a"
import script from "./GenericTHGCO2EquivalentTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericTHGCO2EquivalentTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports